/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ReportingMonetizationTier represents a reporting subscription tier.   - REPORTING_MONETIZATION_TIER_UNSPECIFIED: Unspecified default value.  - REPORTING_MONETIZATION_TIER_STARTER: Starter tier.  - REPORTING_MONETIZATION_TIER_TEAM: Team tier.  - REPORTING_MONETIZATION_TIER_PREMIUM: Premium tier.
 * @export
 * @enum {string}
 */

export const CostreportV1beta1ReportingMonetizationTier = {
    UNSPECIFIED: 'REPORTING_MONETIZATION_TIER_UNSPECIFIED',
    STARTER: 'REPORTING_MONETIZATION_TIER_STARTER',
    TEAM: 'REPORTING_MONETIZATION_TIER_TEAM',
    PREMIUM: 'REPORTING_MONETIZATION_TIER_PREMIUM'
} as const;

export type CostreportV1beta1ReportingMonetizationTier = typeof CostreportV1beta1ReportingMonetizationTier[keyof typeof CostreportV1beta1ReportingMonetizationTier];



